import { getPaymentMethodDetails } from '~/lib/PaymentMethodHelpers';
import { useClientPostApi } from '~/lib/ClientApi';
import { setClientHistoryQuery } from '~/public/lib/PublicQueries';
import { useEffect, useState } from 'react';
import PaymentForm from '~/components/payments/PaymentForm';
import { ObjectTypes } from '~/lib/ObjectTypes';
import Loading from '~/components/Loading';
import ErrorMessage from '~/components/ErrorMessage';
import { isEmbedded } from '~/public/lib/PageHelpers';

const AddNewCard = ({ refetch, client, className }) => {
    const { save: getPaymentSettings, isSaving: isLoading } = useClientPostApi(
        `/account/saved-method/add/${client.id}`,
    );
    const [paymentSettings, setPaymentSettings] = useState(null);

    useEffect(() => {
        getPaymentSettings({
            url: document.location.pathname,
        }).then(result => {
            setPaymentSettings(result);
        });
    }, []);

    return (
        <div className={className}>
            {isLoading && <Loading />}
            {!isLoading && !paymentSettings && (
                <ErrorMessage>
                    Error, failed to get payment form. Please try again later.
                </ErrorMessage>
            )}
            {!!paymentSettings && (
                <div>
                    <div className="panel-label">Add Card</div>
                    <div className="panel p-4">
                        <PaymentForm
                            id={client.id}
                            type={ObjectTypes.CLIENT}
                            paymentBtnLabel="Save"
                            paymentSettings={paymentSettings}
                        />
                    </div>
                </div>
            )}
        </div>
    );
};

const SavedPaymentMethod = ({ paymentMethod, isFirst, refetch }) => {
    const { save: saveMakeDefault, isSaving: isMakingDefault } =
        useClientPostApi(`/account/saved-method/${paymentMethod.id}/default`);
    const { save: saveDelete, isSaving: isDeleting } = useClientPostApi(
        `/account/saved-method/${paymentMethod.id}/delete`,
    );

    function doMakeDefault() {
        saveMakeDefault().then(result => {
            setClientHistoryQuery(result);
        });
    }

    function doDelete() {
        if (confirm('Are you sure you want to delete this payment method?')) {
            saveDelete().then(result => {
                setClientHistoryQuery(result);
            });
        }
    }

    console.log('paymentMethod=', paymentMethod);

    const { title, description } = getPaymentMethodDetails(paymentMethod);

    return (
        <div
            className={`ml-4 py-3 pr-4 ${!isFirst ? 'border-t' : ''} flex items-center justify-between`}
        >
            <div>
                <div className="text-lg flex">
                    {title}
                    {paymentMethod.is_default && (
                        <div className="themed-text text-xs uppercase font-semibold ml-2 mb-1">
                            Default
                        </div>
                    )}
                </div>
                <div className="text-gray-500">{description}</div>
            </div>
            <div>
                {!paymentMethod.is_default && (
                    <button
                        type="button"
                        className="themed-text btn-small mr-4"
                        onClick={doMakeDefault}
                    >
                        {isMakingDefault
                            ? 'Setting as default...'
                            : 'Set as Default'}
                    </button>
                )}
                <button
                    type="button"
                    className="form-button-light btn-small"
                    onClick={doDelete}
                >
                    {isDeleting ? 'Deleting...' : 'Delete'}
                </button>
            </div>
        </div>
    );
};

const ClientAccountBilling = ({ paymentMethods, refetch, client }) => {
    const [showAddNewCard, setShowAddNewCard] = useState(false);
    paymentMethods = paymentMethods || [];
    return (
        <div>
            <div className="panel-label">Saved Cards</div>
            <div className="panel">
                {paymentMethods.map((method, idx) => (
                    <SavedPaymentMethod
                        paymentMethod={method}
                        isFirst={idx === 0}
                        refetch={refetch}
                    />
                ))}
                {paymentMethods.length === 0 && (
                    <div className="p-4">You have no saved payment methods</div>
                )}
            </div>

            {!!client?.id && (
                <button
                    type="button"
                    className="form-button-light mt-4"
                    onClick={() => setShowAddNewCard(!showAddNewCard)}
                >
                    Add New Card
                </button>
            )}

            {showAddNewCard && (
                <AddNewCard
                    client={client}
                    refetch={refetch}
                    className="mt-4"
                />
            )}
        </div>
    );
};

export default ClientAccountBilling;
